// extracted by mini-css-extract-plugin
export default {"resetContraseniaContainer":"ResetContrasenia_resetContraseniaContainer__KMidu"};